<template>
  <el-form :model="this.equip" label-position="left">

    <el-row :gutter="16">
      <el-col :sm="24" :md="12" :lg="8">
        <integer-input label="Weight" v-model="equip.weight" suffix="kg" :disabled="!this.isEdit" />
      </el-col>

      <el-col :sm="24" :md="12" :lg="8">
        <float-input label="Width" v-model="equip.width" suffix="mm." :disabled="!this.isEdit" />
      </el-col>

      <el-col :sm="24" :md="12" :lg="8">
        <integer-input label="Height" v-model="equip.height" suffix="mm." :disabled="!this.isEdit" />
      </el-col>

      <el-col :sm="24" :md="12" :lg="8">
        <integer-input label="Depth" v-model="equip.depth" suffix="mm." :disabled="!this.isEdit" />
      </el-col>

      <el-col :sm="24" :md="12" :lg="8">
        <float-input label="Diameter" v-model="equip.diameter" suffix="⌀ m." :disabled="!this.isEdit" />
      </el-col>

      </el-row>

    </el-form>
</template>

<script>
   export default {

     props: {
       rowData: {
         type: Object,
         required: true
       },
       isEdit: {
         type: Boolean,
         default: false
       }
     },
     data () {
       return {
         equip: this.rowData
       }
     } // data
   }
</script>
